import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardMedia,
  CardContent,
  useTheme,
} from "@mui/material";

// to render HTML content safely
import DOMPurify from "dompurify";

const DynamicPage = ({ pageData }) => {
  const theme = useTheme();

  if (!pageData) return null;

  const {
    title,
    excerpt,
    content,
    feature_image_url,
    created_at,
  } = pageData;

  return (
    <Box sx={{ bgcolor: "background.default", py: { xs: 4, md: 8 } }}>
      <Container maxWidth="lg">
        {/* Page Card */}
        <Card sx={{ borderRadius: 3, boxShadow: 4, overflow: "hidden" }}>
          {feature_image_url && (
            <CardMedia
              component="img"
              height="300"
              image={feature_image_url}
              alt={title}
              sx={{ objectFit: "cover" }}
            />
          )}
          <CardContent sx={{ p: { xs: 2, md: 4 } }}>
            {/* Title */}
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                color: theme.palette.primary.main,
              }}
            >
              {title}
            </Typography>

            {/* Excerpt */}
            {excerpt && (
              <Typography
                variant="subtitle1"
                color="text.secondary"
                align="center"
                gutterBottom
              >
                {excerpt}
              </Typography>
            )}

            {/* Content */}
            <Box
              sx={{
                mt: 3,
                typography: "body1",
                "& p": { mb: 2, lineHeight: 1.7 },
                "& h2, & h3": { mt: 3, mb: 2, fontWeight: "bold" },
                "& ul": { pl: 3, mb: 2 },
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(content || ""),
              }}
            />

            {/* Date */}
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 4, textAlign: "right" }}
            >
              Published: {new Date(created_at).toLocaleDateString()}
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default DynamicPage;
